import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4898762"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "support-description" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "support-description_actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3678_12455)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4.84125 14.25L1.5 16.875V3C1.5 2.80109 1.57902 2.61032 1.71967 2.46967C1.86032 2.32902 2.05109 2.25 2.25 2.25H15.75C15.9489 2.25 16.1397 2.32902 16.2803 2.46967C16.421 2.61032 16.5 2.80109 16.5 3V13.5C16.5 13.6989 16.421 13.8897 16.2803 14.0303C16.1397 14.171 15.9489 14.25 15.75 14.25H4.84125ZM4.32225 12.75H15V3.75H3V13.7887L4.32225 12.75ZM8.25 7.5H9.75V9H8.25V7.5ZM5.25 7.5H6.75V9H5.25V7.5ZM11.25 7.5H12.75V9H11.25V7.5Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3678_12455" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "18",
        height: "18",
        fill: "white"
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_button = _resolveComponent("ac-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "support-description_text",
      innerHTML: _ctx.category.description
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.category.allowAutoResolve)
        ? (_openBlock(), _createBlock(_component_ac_button, {
            key: 0,
            class: "support-description_button -autoResolve",
            disabled: _ctx.autoResolveBtnDisabled,
            onClick: _ctx.autoResolveHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.category.submitButtonText), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : (_openBlock(), _createBlock(_component_ac_button, {
            key: 1,
            class: "support-description_button -tech",
            onClick: _ctx.showTechHandler
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('writeInSupport')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
    ])
  ]))
}